import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndoAlt, faRedoAlt, faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import { appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import { connect } from "react-redux";
import ReactTable from "react-table";
import { 
  Input, 
  Row, 
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
  CustomInput,
  } from 'reactstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import {
  fetchLocationResultsData,
  fetchBuilding,
  fetchFloors,
  fetchFloorPlan,
  saveLocation,
  deleteMultipleLocations
} from '../../actions';
import Pagination from '../Pagination/pagination';
import deleteIcon from '../../assets/deleteIconRebrand.svg';
import addButton from '../../assets/addButton.svg';
import availLocs from '../../assets/availableLocations.png';
import collapseIcon from '../../assets/collapse.svg'

let errorDetails = ""

class Canvas extends React.Component {
    constructor(props) {
      super(props);
      this.deleteMultipleLocations =this.deleteMultipleLocations.bind(this)
      this.state = {
        isDrawing : false,
        current: 0,
        locationData: [{coordinates: [], rect_coordinates: [], location_id: "", room: "", description: ""}],
        redo: [],
        coordinatesSelect: 0,
        checked: [],
        isMultiDeleteModalOpen: false,
        toggleAvailableLocs : true,
        customStyles:{
          menuPortal: provided => ({ 
            ...provided, 
            zIndex: 100, 
          }),
          menu: provided => ({ 
            ...provided, 
            zIndex: 9999 
          }),
          control: base => ({
            ...base,
            height: 32,
            minHeight: 32,
            borderRadius:4,
            border: '0.5px solid #6d93bd',
            zIndex:0,
          }),
          placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                paddingLeft:'-100px',
            }
          }
        },
        listOfRooms: []
      }
      this.canvasRef = React.createRef(null);
    	this.contextRef = React.createRef(null);
      this.selected = -1;
      this.selectedFig = -1;
      this.drag = false;
      this.point = [];
    }

    getCoordList = (coordinates) =>{
      let shape = []
      let point = []
      if(coordinates===""||coordinates == null)
      return []
      coordinates.split(",").forEach((item, index) =>{
          if(index%2 === 0)
          point = [item]
          else{
          point.push(item)
          shape.push(point)
        }
        })
      return shape
  }
  
  getLoctionsData = () =>{
    let intialData = []
    this.props.locationAreas.locations_data.data.forEach((data)=>{
        intialData.push({
            coordinates: this.getCoordList(data.coordinates),
            rect_coordinates: data.rect_coordinates?this.getCoordList(data.rect_coordinates):[],
            room: data.room.room_name+', '+data.room.room_id,
            location_id: data.location_id,
            description: data.description,
        })
    })
    return intialData
  }
    componentDidMount(props) {
    // Use setTimeout to ensure canvas is fully rendered
    setTimeout(() => {
      if (this.canvasRef.current) {
        const canvas = this.canvasRef.current
        const context = canvas.getContext("2d")
        if (context) {
          context.lineCap = "round";
          context.strokeStyle = "black";
          context.lineWidth = 7;
          this.contextRef.current = context;
          console.log('componentDidMount - Context initialized, canvas size:', canvas.width, 'x', canvas.height);
          this.drawing()
        } else {
          console.error('componentDidMount - Could not get context');
        }
      } else {
        console.error('componentDidMount - Canvas ref not available');
      }
    }, 100);
  }

  columns = [
    {
      Header: state => (
        <>
        </>
        ),
      id: 'checkbox',
      accessor: str => "checkbox",
      Cell: (row) => {
        let checked = this.state.checked.includes(row.index)
        return <CustomInput type="checkbox" className={checked?"custom-table-checkbox-addlocationPage select-checked":"custom-table-checkbox-addlocationPage"} id={row.original.id} checked={checked} onClick={() => this.handleCheckClick(row.index)}/>
    },
      width: 50,
      filterable:false,
      headerClassName: 'checkbox-sticky-style',
      className: 'checkbox-sticky-style '
   },
    {
        Header: 'Location ID',
        accessor: 'location_id',
        width:180,
    },
    {
        Header: 'Description',
        accessor: 'description',
        width:290,
    },
    {
        Header: 'Room',
        id: 'room',
        accessor: str => 'room',
        Cell: (row) => {
          return <div>{row.original.room.room_name + ', ' + row.original.room.room_id}</div>
        },
        width:200,
    },
    {
        Header: 'Coordinates',
        accessor: "coordinates",
        width:180,
    },
    {
      Header: 'Rectangular Coordinates',
      accessor: "rect_coordinates",
      width:220,
    },
  ]

    componentDidUpdate(prevProps) {
      if (prevProps.height !== this.props.height || prevProps.width !== this.props.width || 
            prevProps.image !== this.props.image || prevProps.locationAreas !== this.props.locationAreas) {
        // Re-initialize canvas context if needed
        if (this.canvasRef.current && !this.contextRef.current) {
          const context = this.canvasRef.current.getContext("2d");
          if (context) {
            context.lineCap = "round";
            context.strokeStyle = "black";
            context.lineWidth = 7;
            this.contextRef.current = context;
          }
        }
        this.clearCanvas();
      }
      // Update listOfRooms when rooms prop changes
      if (prevProps.rooms !== this.props.rooms) {
        this.setDropdown();
      }
    }

    drawing = () => {
      if (!this.contextRef.current || !this.canvasRef.current) {
        console.log('drawing - context or canvas not available');
        return;
      }
      console.log('drawing - Clearing canvas and redrawing');
      this.contextRef.current.clearRect(0, 0, this.canvasRef.current.width, this.canvasRef.current.height)
      this.drawingList(this.getLoctionsData(), true)
      this.drawingList()
    }
    drawingList = (data=this.state.locationData, color=false) => {
        if (!this.contextRef.current) {
          return;
        }
        if(this.state.coordinatesSelect===0 && this.state.locationData[this.state.current] && this.state.locationData[this.state.current].coordinates) {
          console.log('drawingList - Drawing', this.state.locationData[this.state.current].coordinates.length, 'points');
          this.state.locationData[this.state.current].coordinates.forEach((point) =>{
            if (this.contextRef.current && point && point.length === 2) {
              this.contextRef.current.beginPath()
              this.contextRef.current.arc(point[0], point[1], 5, 0, 2 * Math.PI, false);
              this.contextRef.current.fillStyle = 'black';
              this.contextRef.current.fill();
              this.contextRef.current.stroke();
            }
          })
        }
        else if(this.state.locationData[this.state.current] && this.state.locationData[this.state.current].rect_coordinates)
          this.state.locationData[this.state.current].rect_coordinates.forEach((point) =>{
            if (this.contextRef.current) {
              this.contextRef.current.beginPath()
              this.contextRef.current.rect(...point, 2, 2);
              this.contextRef.current.stroke();
            }
          })

      data.forEach((location) =>{
        if (!this.contextRef.current) {
          return;
        }
        this.contextRef.current.fillStyle =color?"rgb(117,150,248, 0.3)":"rgba(0, 0, 0, 0.3)";
        if(location.coordinates.length===2 && !location.room.startsWith("Unknown Room"))
          this.contextRef.current.fillRect(location.coordinates[0][0], location.coordinates[0][1], 
            location.coordinates[1][0]-location.coordinates[0][0], location.coordinates[1][1]-location.coordinates[0][1])
        if(location.coordinates.length>2 && !location.room.startsWith("Unknown Room")){
          this.contextRef.current.beginPath()
          this.contextRef.current.moveTo(...location.coordinates[0])
          location.coordinates.forEach((point, index, data) =>{
            if (this.contextRef.current) {
              this.contextRef.current.lineTo(...data[(index+1)%data.length])
            }
          })
          this.contextRef.current.closePath()
          this.contextRef.current.fill()

          if(location.rect_coordinates.length===2 && !location.room.startsWith("Unknown Room"))
          this.contextRef.current.fillRect(location.rect_coordinates[0][0], location.rect_coordinates[0][1], 
            location.rect_coordinates[1][0]-location.rect_coordinates[0][0], location.rect_coordinates[1][1]-location.rect_coordinates[0][1])
        }
      })
    }


    selectedPoint = (coordinates, offsetX, offsetY) =>{
      let pointIndex = -1
      coordinates.every((point, index) =>{
        if(offsetX<point[0]+10 && offsetX>point[0]-10 && offsetY<point[1]+10 && offsetY>point[1]-10){
          pointIndex = index
          return false
        }
        return true;
      })
      if (this.canvasRef.current) {
        this.canvasRef.current.style.cursor = pointIndex===-1?"Default":"pointer"
      }
      return pointIndex
    }

    isInside = (ploygon, point) =>
    {
      let isIn = 0;
      for (let i = 0, j = ploygon.length-1; i < ploygon.length; j = i++) {
        if ((((ploygon[i][1] <= point[1]) && (point[1] < ploygon[j][1])) ||
             ((ploygon[j][1] <= point[1]) && (point[1] < ploygon[i][1]))) &&
            (point[0] < (ploygon[j][0] - ploygon[i][0]) * (point[1] - ploygon[i][1]) / (ploygon[j][1] - ploygon[i][1]) + ploygon[i][0]))
            isIn = !isIn;
      }
      return isIn;
    }

    selectedShape = (offsetX, offsetY) =>{
      let shapeIndex = -1
      this.state.locationData.every((shape, index) =>{
        if((shape.coordinates.length!==2 && this.isInside(shape.coordinates, [offsetX, offsetY])) || 
          (shape.coordinates.length===2 && this.isInside([shape.coordinates[0], [shape.coordinates[0][0], shape.coordinates[1][1]], shape.coordinates[1], [shape.coordinates[1][0], shape.coordinates[0][1]]], [offsetX, offsetY])))
          {
            shapeIndex = index;
            return false
          }
        return true;
      })
      if (this.canvasRef.current) {
        this.canvasRef.current.style.cursor = shapeIndex===-1?"Default":"pointer"
      }
      return shapeIndex
    }

    startDrawing = ({ nativeEvent }) => {
      if (!this.canvasRef.current) {
        return;
      }
      // Ensure context is initialized
      if (!this.contextRef.current && this.canvasRef.current) {
        const context = this.canvasRef.current.getContext("2d");
        if (context) {
          context.lineCap = "round";
          context.strokeStyle = "black";
          context.lineWidth = 7;
          this.contextRef.current = context;
          console.log('startDrawing - Context initialized');
        }
      }
      const { offsetX, offsetY } = nativeEvent;
      this.drag = false;
      if(this.state.coordinatesSelect===0)
        this.selected = this.selectedPoint( this.state.locationData[this.state.current].coordinates, offsetX, offsetY)
      else
      this.selected = this.selectedPoint( this.state.locationData[this.state.current].rect_coordinates, offsetX, offsetY)
      if(this.selected<0){
          this.selectedFig = this.selectedShape(offsetX, offsetY);
      }
      this.point = (this.selected < 0)?[offsetX, offsetY]: [] 
      console.log('startDrawing - point:', this.point, 'offsetX:', offsetX, 'offsetY:', offsetY, 'context available:', !!this.contextRef.current);
    };

    handleMouseMove = ({ nativeEvent }) => {
      if (!this.canvasRef.current) {
        return;
      }
      const { offsetX, offsetY } = nativeEvent;
      let currentPoint = this.state.locationData
      // Only set drag to true if mouse actually moved (not just initial move)
      if (this.point.length === 2) {
        const [startX, startY] = this.point;
        const distance = Math.sqrt(Math.pow(offsetX - startX, 2) + Math.pow(offsetY - startY, 2));
        if (distance > 5) { // Only consider it a drag if moved more than 5 pixels
          this.drag = true;
        }
      }
      if (this.selected < 0 && this.selectedFig<0) {
          let point = this.selectedPoint(this.state.locationData[this.state.current].coordinates, offsetX, offsetY)
          if(point<0)
          this.selectedShape(offsetX, offsetY);
          return;
      }
      if(this.selected>=0){
        if(this.state.coordinatesSelect===0)
          currentPoint[this.state.current].coordinates[this.selected] = [offsetX, offsetY]
        else if(currentPoint[this.state.current].rect_coordinates.length===1 && 
          this.isInside(currentPoint[this.state.current].coordinates, [offsetX, offsetY]))
          currentPoint[this.state.current].rect_coordinates[this.selected] = [offsetX, offsetY]
        else if(currentPoint[this.state.current].rect_coordinates.length===2 && 
          this.isInside(currentPoint[this.state.current].coordinates, [offsetX, offsetY]) &&
          this.isInside(currentPoint[this.state.current].coordinates, [currentPoint[this.state.current].rect_coordinates[(this.selected+1)%2][0], offsetY]) &&
          this.isInside(currentPoint[this.state.current].coordinates, [offsetX, currentPoint[this.state.current].rect_coordinates[(this.selected+1)%2][1]]))
          currentPoint[this.state.current].rect_coordinates[this.selected] = [offsetX, offsetY]
        else{
          this.selected = -1;
          if (this.canvasRef.current) {
            this.canvasRef.current.style.cursor = "default";
          }
        }
        this.setState({locationData: currentPoint, redo: []}, this.drawing)
      }
      else if(this.selectedFig>=0)
      {
        let diff = [offsetX-this.point[0], offsetY-this.point[1]]
        currentPoint[this.selectedFig].coordinates.forEach((point, pointIndex) =>{
          currentPoint[this.selectedFig].coordinates[pointIndex] = [point[0]+diff[0], point[1]+diff[1]]
        })
        currentPoint[this.selectedFig].rect_coordinates.forEach((point, pointIndex) =>{
          currentPoint[this.selectedFig].rect_coordinates[pointIndex] = [point[0]+diff[0], point[1]+diff[1]]
        })
        this.point = [offsetX, offsetY]
        this.setState({locationData: currentPoint, redo: []}, this.drawing)
      }
  }

    handleMouseUp = (e) => {
      if (!this.canvasRef.current) {
        console.log('handleMouseUp - canvas not available');
        return;
      }
      // Ensure context is initialized
      if (!this.contextRef.current) {
        const context = this.canvasRef.current.getContext("2d");
        if (context) {
          context.lineCap = "round";
          context.strokeStyle = "black";
          context.lineWidth = 7;
          this.contextRef.current = context;
          console.log('handleMouseUp - Context initialized');
        } else {
          console.log('handleMouseUp - Could not get context');
          return;
        }
      }
      console.log('handleMouseUp - drag:', this.drag, 'point.length:', this.point.length, 'point:', this.point);
      if(!this.drag && this.point.length===2){
        const offsetX = this.point[0];
        const offsetY = this.point[1];
        console.log('handleMouseUp - Adding point:', offsetX, offsetY);
        if (this.contextRef.current) {
          this.contextRef.current.beginPath();
          this.contextRef.current.moveTo(offsetX, offsetY);
        }
        let currentPoint = this.state.locationData
        if(this.state.coordinatesSelect===0){
          currentPoint[this.state.current].coordinates.push([offsetX, offsetY])
          console.log('handleMouseUp - Updated coordinates:', currentPoint[this.state.current].coordinates);
          this.setState({locationData: currentPoint, redo: []}, () => {
            console.log('handleMouseUp - State updated, calling drawing');
            this.drawing();
          })
        }
        else if(currentPoint[this.state.current].rect_coordinates.length===0 && 
          this.isInside(currentPoint[this.state.current].coordinates, [offsetX, offsetY])){
          currentPoint[this.state.current].rect_coordinates.push([offsetX, offsetY])
          this.setState({locationData: currentPoint, redo: []}, () => {
            console.log('handleMouseUp - State updated (rect), calling drawing');
            this.drawing();
          })
          }
        else if(currentPoint[this.state.current].rect_coordinates.length===1 && 
          this.isInside(currentPoint[this.state.current].coordinates, [offsetX, offsetY]) &&
          this.isInside(currentPoint[this.state.current].coordinates, [currentPoint[this.state.current].rect_coordinates[0][0], offsetY]) &&
          this.isInside(currentPoint[this.state.current].coordinates, [offsetX, currentPoint[this.state.current].rect_coordinates[0][1]])){
            currentPoint[this.state.current].rect_coordinates.push([offsetX, offsetY])
            this.setState({locationData: currentPoint, redo: []}, () => {
              console.log('handleMouseUp - State updated (rect 2), calling drawing');
              this.drawing();
            })
            }
      }
      this.selected = -1;
      this.selectedFig = -1;
      if (this.canvasRef.current) {
        this.canvasRef.current.style.cursor = "pointer";
      }
      this.point = []
    }

    handleMouseOut = (e) => {
      this.selected = -1;
      this.canvasRef.current.style.cursor = "default";
    }

    handleButtonClick = (event) => {
      const { value } = event.target;
      this.setState({current: parseInt(value), coordinatesSelect: 0, redo:[]}, this.drawing)
    };

    handleChangeCorrds = (event) => {
      let currentPoint = this.state.locationData
      let shape = this.getCoordList( event.target.value)
      if(this.state.coordinatesSelect===0)
        currentPoint[this.state.current].coordinates = shape
      else
        currentPoint[this.state.current].rect_coordinates = shape.length>2?shape.slice(0, 2):shape
      this.setState({locationData: currentPoint}, this.drawing)
    };

    handleDeleteClick = (index) =>{
      if(this.state.locationData.length === 1){
        this.clearCanvas()
        return
      }
      let currentPoint = this.state.locationData
      currentPoint.splice(index, 1);
      this.setState({
        locationData: currentPoint,
        current: this.state.current<index? this.state.current: this.state.current-1,
        coordinatesSelect: this.state.current<index? this.state.coordinatesSelect:0,
        redo: []
      }, this.drawing)
    }

    handleChange = (event, index) => {
      let currentPoint = this.state.locationData
      currentPoint[index][event.target.name] = event.target.value
      this.setState({locationData: currentPoint})
  };
  
  setDropdown = () => {
    if(this.props.rooms && this.props.rooms.length > 0){
      const newListOfRooms = this.props.rooms.map(room => ({
        label: room.room_name, 
        value: room.id+') '+room.room_name+','+room.room_id
      }));
      this.setState({ listOfRooms: newListOfRooms });
    }
  }
  
  componentDidUpdate(prevProps) {
    // Update listOfRooms when rooms prop changes
    if (prevProps.rooms !== this.props.rooms) {
      this.setDropdown();
    }
  }
  
  componentDidMount() {
    // Initialize listOfRooms on mount
    if (this.props.rooms && this.props.rooms.length > 0) {
      this.setDropdown();
    }
  }

  onSelectRoom = (event, index) => {
      let currentPoint = this.state.locationData
      let room_name = event.value.split(',')[0].split(') ')[1]
      let room_id = event.value.split(',')[1]
      let id = event.value.split(',')[0].split(') ')[0]
      currentPoint[index]["description"] = this.props.building.buildingName + "_" + this.props.floor.floorName +"_"+ room_name
      currentPoint[index]["room"] = id
      this.setState({locationData: currentPoint})
  }  

    isCtrlPressed = (event) => event.ctrlKey || event.metaKey;
    isShiftPressed = (event) => event.shiftKey;

    onKeyDown = (event) => {
        let isCtrl = this.isCtrlPressed(event);
        let isShift = this.isShiftPressed(event);
        let Z = 90;
        if (isCtrl && event.which === Z && !isShift){
          this.handleUndo() 
        }
        if (isCtrl && isShift && event.which === Z){
          this.handleRedo()
        }
    }

  handleUndo = () =>{
    let currentPoint = this.state.locationData
    let locationLen
    if(this.state.coordinatesSelect===0)
      locationLen = currentPoint[this.state.current].coordinates.length
    else
      locationLen = currentPoint[this.state.current].rect_coordinates.length
    if(locationLen<=0)
      return
    let data
    if(this.state.coordinatesSelect===0)
      data = currentPoint[this.state.current].coordinates.pop();
    else
      data = currentPoint[this.state.current].rect_coordinates.pop();
    this.setState({
      locationData: currentPoint,
      redo: [...this.state.redo, data]
    }, this.drawing)
  }

  handleRedo = () =>{
    if(this.state.redo.length<=0)
      return
    let currentPoint = this.state.locationData
    let tempRedo = this.state.redo
    if(this.state.coordinatesSelect===0)
      currentPoint[this.state.current].coordinates.push(tempRedo.pop());
    else
      currentPoint[this.state.current].rect_coordinates.push(tempRedo.pop());
    this.setState({
      locationData: currentPoint,
      redo: tempRedo
    }, this.drawing)
  }
  
  handleChangeCoordSelect = (value) =>{
      this.setState({
          ...this.state,
          redo: [],
          coordinatesSelect: value
      }, this.drawing)
  }


  saveAll = () => {
    if (this.validateData(this.state)) {
      let createData = this.state.locationData.map((location) => {
        let data = {...location}
        data.coordinates = location.coordinates.join()
        
        // Gerar coordenadas retangulares automaticamente se não existirem
        let rectCoords = location.rect_coordinates;
        if (rectCoords.length < 2 && location.coordinates.length > 0) {
          // Calcular bounding box das coordenadas normais
          const xs = location.coordinates.map(coord => coord[0]);
          const ys = location.coordinates.map(coord => coord[1]);
          const minX = Math.min(...xs);
          const maxX = Math.max(...xs);
          const minY = Math.min(...ys);
          const maxY = Math.max(...ys);
          rectCoords = [[minX, minY], [maxX, maxY]];
        }
        
        data.rect_coordinates = rectCoords.length > 0 ? rectCoords.join() : ""
        data["floor"] = this.props.floor.id
        data["building"] = this.props.building.id
        return data
      })
      this.props.saveLocation(createData).then(response => {
        if (response.status === 201) {
            let message = "Locations are successfully added!"
            if (appInsights && appInsights.trackEvent) {
              appInsights.trackEvent({name:'Locations Added', properties:{id: response.data.map( data => data.location_id)}});
            }
            if (appInsights && appInsights.trackTrace) {
              appInsights.trackTrace({message: 'Locations Added', properties:{id: response.data.map( data => data.location_id)}, severityLevel: SeverityLevel.Information});
            }
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
          this.props.fetchLocations()
        }
        else {
            this.props.fetchRooms()
            let message = "Locations couldn't be added!"
            if (appInsights && appInsights.trackTrace) {
              appInsights.trackTrace({message: message, properties:{id: this.state.locationData.map((location)=>location.location_id)}, severityLevel: SeverityLevel.Error});
            }
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    }).catch((error) => {
      let message = "Locations couldn't be added!"
      if (appInsights && appInsights.trackTrace) {
        appInsights.trackTrace({message: message, properties:{id: this.state.locationData.map((location)=>location.location_id), error: error}, severityLevel: SeverityLevel.Error});
      }
      toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT
      })
    })
    }
    else
      this.ErrorDetails()
  }

  ErrorDetails = () => {
    if (appInsights && appInsights.trackTrace) {
      appInsights.trackTrace({message: errorDetails, severityLevel: SeverityLevel.Verbose});
    }
    toast.error(errorDetails, {
        position: toast.POSITION.BOTTOM_RIGHT
    })
    errorDetails = ""
    return true
}
  validateData = (data) => {
    var loctaionsSoFar = Object.create(null);
    let isValid = data.locationData.every((location) => {
    if(!location.description || location.description.trim().length === 0){
      errorDetails = "Description is missing for "+location.location_id+" !"
      return false
    }
    // Para polígonos complexos (mais de 2 pontos), coordenadas retangulares são opcionais
    // A geração automática será feita no saveAll() antes de salvar
    else if(location.coordinates.length<1){
      errorDetails = "Invalid Coordinates for "+location.location_id+" !"
      return false
    }
    else if (!location.room) {
      errorDetails = "Select the Room from the drop down!"
      return false
  }
    return true
  })
    return isValid
  }

  clearCanvas = () => {
    if (!this.contextRef.current || !this.canvasRef.current) {
      return;
    }
    this.selectedText = -1;
    this.contextRef.current.lineCap = "round";
    this.contextRef.current.lineWidth = 7;
    this.contextRef.current.clearRect(0, 0, this.canvasRef.current.width, this.canvasRef.current.height)
    this.setState({
      locationData: [{coordinates: [], rect_coordinates: [], location_id: "", room:"", description: ""}], 
      current: 0, 
      coordinatesSelect: 0,
      redo: [],
    }, ()=> this.drawingList(this.getLoctionsData(), true))
  }

  addNewArea = () =>{
    let currentPoint = this.state.locationData
    currentPoint.push({coordinates: [], rect_coordinates: [], location_id: "", room:"", description: ""})
    this.setState({locationData: currentPoint, current: currentPoint.length-1, coordinatesSelect: 0, redo:[]}, this.drawing)
  }

deleteMultipleLocations = () => {
    let ids = this.state.checked.map((id) => this.props.locationAreas.locations_data.data[id].location_id)
    this.props.deleteMultipleLocations(ids).then(response => {
      if (response.status === 204) {
        let message = "Locations Deleted Successfully!"
        if (appInsights && appInsights.trackEvent) {
          appInsights.trackEvent({ name: 'Locations Deleted', properties: { id: ids } });
        }
        if (appInsights && appInsights.trackTrace) {
          appInsights.trackTrace({ message: message, properties: { id: ids }, severityLevel: SeverityLevel.Information });
        }
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT
        });
        this.props.fetchLocations()
      }
      else {
        let message = "Locations couldn't be deleted!"
        if (appInsights && appInsights.trackTrace) {
          appInsights.trackTrace({ message: message, properties: { id: ids }, severityLevel: SeverityLevel.Error });
        }
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT
        });
      }
      this.setState({
        isMultiDeleteModalOpen: false,
        checked: [],
      })
    }
    )
  }

toggleMultiDeleteModal = () => {
  this.setState(prevState => ({
      isMultiDeleteModalOpen: !prevState.isMultiDeleteModalOpen,
  }));
}

  handleCheckClick = (value) =>{
    this.setState(prevState => ({
        checked: prevState.checked.includes(value)?[...prevState.checked.filter((val) => val !== value)]:[...prevState.checked, value],
    }))
  }

  selectAll = () => {
    this.setState({
    checked: this.state.checked.length < this.props.locationAreas.locations_data.data.length?[...Array(this.props.locationAreas.locations_data.data.length).keys()]:[]})
  }

  toggleAvailableLocations = () => {
    this.toggleAvailableLocs = !this.toggleAvailableLocs
    this.setState(prevState => ({
      toggleAvailableLocs: !prevState.toggleAvailableLocs,
    }));
  }
  
  render() { 
      return (  
        <div id="undoRedo" tabIndex="0" onKeyDown={this.onKeyDown}>
          <div data-tut="reactour__addLocation">
            <div className="canvas-scroll">
            <div className="canvas-border">
              <canvas
                  tabIndex="1"
                  height={this.props.height}
                  width={this.props.width}
                  style={{marginRight:'5%', color: "black", backgroundImage: `url(${this.props.image})`, backgroundSize: "cover"}}
                  onMouseDown={this.startDrawing}
                  onMouseMove={this.handleMouseMove}
                  onMouseUp={this.handleMouseUp}
                  onMouseOut={this.handleMouseOut}
                  ref={this.canvasRef}
              />
            </div>
            </div>
            <div>
            <Row form className="canvas-border" >
                <Col className="overview pb-md-0 map-location-heading" md={2} lg={2} xl={2}>Map Rooms</Col>
                <Col className ="d-flex justify-content-end  redo-undo-padding">
                  <div title="Undo" className="mr-2-p" onClick={this.handleUndo}>
                    <FontAwesomeIcon className="icons mt-0 undo-icon-style" id={"undoButton"} icon={faUndoAlt} size="lg"> 
                    </FontAwesomeIcon>
                    <span className ="redo-undo-text">Undo</span>
                  </div>
                  <div title="Redo" onClick={this.handleRedo}>
                    <FontAwesomeIcon className="icons mt-0 undo-icon-style" id={"redoButton"} icon={faRedoAlt} size="lg">
                    </FontAwesomeIcon>
                    <span className ="redo-undo-text">Redo</span>
                  </div>
                </Col>
              </Row>
              {this.state.locationData.map((location, index)=>(
              <Row form className="mt-20" key={index}>
                <div className="result-input result-input-check-box" >
                  <Input type="checkbox" className="map-location-checkbox" value={index} checked={this.state.current === index} onChange={this.handleButtonClick} />
                </div>
                <Col className="mr-0 dropdown-select-col" md={4} xl={3} lg={3}>
                  <Select 
                    className="dropdown-select-room" 
                    placeholder={'Select Room...'} 
                    menuPortalTarget={document.body} 
                    styles={this.state.customStyles} 
                    options={this.state.listOfRooms} 
                    onChange={(e) => this.onSelectRoom(e, index)}
                    value={location.room ? this.state.listOfRooms.find(room => room.value.split(',')[0].split(') ')[0] === location.room) : null}
                  />
                </Col>
                <Col md={4} xl={2} lg={2}>
                  <Input className={location.description ? "sample-input-fields mt-0" : "sample-input-fields default-disabled mt-0"} type="text" name="description" value={location.description} onChange={(e) => this.handleChange(e, index)} placeholder="Description" />
                </Col>
                <Col md={4} xl={2} lg={2}>
                  <Input className={this.state.current === index && this.state.coordinatesSelect === 0 ? "active-corrods-boxing manage-notification-input sample-input-fields mt-0" : "edit-input-values manage-notification-input sample-input-fields mt-0"} type="text" value={location.coordinates.join()} onFocus={() => this.handleChangeCoordSelect(0)} onChange={() => {}} placeholder="Coordinates" disabled={this.state.current !== index} readOnly={this.state.current !== index} />
                </Col>
                <Col md={4} xl={2} lg={2}>
                  <Input className={this.state.current === index && this.state.coordinatesSelect === 1 ? "active-corrods-boxing manage-notification-input sample-input-fields mt-0" : "edit-input-values manage-notification-input sample-input-fields mt-0"} type="text" value={location.rect_coordinates.join()} onFocus={() => this.handleChangeCoordSelect(1)} onChange={() => {}} placeholder="Rectangular Coords" disabled={location.coordinates.length <= 2 || this.state.current !== index} readOnly={location.coordinates.length <= 2 || this.state.current !== index} />
                </Col>
                <div title="Delete">
                <img src={deleteIcon} className="delete-button-width default-cursor" id={"deleteButton" + index} onClick={() => this.handleDeleteClick(index)}></img>
                </div>
              </Row>
              ))} 
            </div>
          <div data-tut="reactour__applyLocations" className="canvas-border canvas-buttons">
          <Button className="clear-filter-button button-size cancel-buttons manage-page-clear-button btn btn-outline-secondary" type="reset" onClick={this.clearCanvas}>Clear All</Button>
            <Button className="save-all-button" id="saveButton" type="submit" onClick={this.saveAll}>Save All</Button>
            <Button className="add-new-area" onClick={this.addNewArea}>New Area</Button>
          </div>
        </div>
        <div className="d-flex justify-content-between available-locations">
        <div className="available-locations-heading mt-0 ml-2">
          <img src={availLocs} alt="" width="20" className="availLocs"/>
          Available Locations
        </div>
        {this.props.locationAreas.locations_data.data.length>0?
          <div className={this.state.checked.length>0?'avail-location-delete':'avail-location-delete disable-delete'} data-tut="reactour__tableDelete">
            <Button className="delete-unit-button" onClick={this.state.checked.length>0?this.toggleMultiDeleteModal:undefined}>
              <img src={deleteIcon} alt="" className="delete-icon-position"/><span className="delete-text">Delete</span>
            </Button>
          <Button className="toggle-available-location">
            {this.state.toggleAvailableLocs? 
              <img src={collapseIcon} alt="" className="add-icon" id="collapse-icon" width="20" onClick={() => this.toggleAvailableLocations()}/>
              :
              <img src={addButton} alt="" className="add-icon" id="add-icon" width="20" onClick={() => this.toggleAvailableLocations()}/>
            }  
          </Button>
          </div>
        :
        null}
        </div>
          {this.props.locationAreas.locations_data.data.length>0 && this.state.toggleAvailableLocs?    
                <div data-tut="reactour__locations" className='avail-locations-table'>    
                    <ReactTable className="Data-Table avail-locations-table"
                        data={this.props.locationAreas.locations_data.data}
                        PaginationComponent={Pagination}
                        columns={this.columns}
                        showPagination={true}
                        minRows={0}
                        defaultPageSize = {5}
                        sortable={false}
                        getTrProps={(state, rowInfo) => {
                          if (rowInfo && rowInfo.row) {
                            return {
                              onClick: () => { this.handleCheckClick(rowInfo.index) },
                              className: this.state.checked.includes(rowInfo.index) ? "table-selected-row" : "",
                            }
                          }else{
                            return {}
                          }
                        }
                      }
                    />
                </div>
            :
              <Row>
              {this.state.toggleAvailableLocs || this.props.locationAreas.locations_data.data.length===0 ?   
                <Col className="map-location-text"> Floorplan doesn't have any locations added. Please add them!</Col>
                : <Col></Col>
              }
              </Row>
            }
              <Modal isOpen={this.state.isMultiDeleteModalOpen} toggle={this.toggleMultiDeleteModal}>
                    <ModalHeader toggle={this.toggleMultiDeleteModal} className="edit-popup delete-title">
                      <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle}/>
                      Delete Locations
                    </ModalHeader>
                    <ModalBody className="delete-popup-body delete-popup-body-align">
                        Are you sure you want to delete the Locations selected ?
                        <div className="edit-popup-message"><span className="required-icon">Warning: </span>This will also delete Samples and Results in this Location.</div>
                    </ModalBody>
                    <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                      <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary" onClick={this.toggleMultiDeleteModal}>No</Button>
                      <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteMultipleLocations}>Yes</Button>
                    </ModalFooter>
                </Modal>
        </div>)
      }
    }

const mapStateToProps = state => {
  return {
      locationAreas: state.location_data.locationData,
      buildingList: state.floor_data.buildingsList,
      floorsList: state.floor_data.floorsList,
  }
}

export default connect(
  mapStateToProps,
  {
      fetchLocationResultsData,
      fetchBuilding,
      fetchFloors,
      fetchFloorPlan,
      saveLocation,
      deleteMultipleLocations,
  }
)(Canvas)